import { makeStyles, Menu, MenuItem } from '@paintscout/ui'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import type { View } from 'react-big-calendar'
import React, { useState } from 'react'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0),
    backgroundColor: theme.paintscout.palette.brand.Neutral.P94,
    borderRadius: theme.borderRadius.md,
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    paddingLeft: theme.spacing(1.25),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    color: theme.paintscout.palette.brand.Neutral.P30,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    lineHeight: 1.5,
    '&:hover': {
      backgroundColor: theme.paintscout.palette.brand.Neutral.P90
    },
    '&:focus': {
      outline: 'none'
    }
  },
  icon: {
    color: theme.paintscout.palette.brand.Neutral.P50,
    fontSize: theme.typography.pxToRem(20),
    marginLeft: theme.spacing(0.5)
  }
}))

const VIEW_LABELS: Record<string, string> = {
  agenda: 'Schedule',
  day: 'Day',
  week: 'Week',
  month: 'Month'
}

export interface MapViewSwitcherProps {
  value: View
  onChange: (view: View) => void
  includeSchedule?: boolean
}

export default function MapViewSwitcher({ value, onChange, includeSchedule }: MapViewSwitcherProps) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const options: View[] = includeSchedule
    ? (['agenda', 'day', 'week', 'month'] as View[])
    : (['day', 'week', 'month'] as View[])

  const handleSelect = (view: View) => {
    onChange(view)
    setAnchorEl(null)
  }

  return (
    <>
      <button type="button" className={classes.button} onClick={(e) => setAnchorEl(e.currentTarget)}>
        {VIEW_LABELS[value] ?? value}
        <KeyboardArrowDown className={classes.icon} />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {options.map((view) => (
          <MenuItem key={view} selected={view === value} onClick={() => handleSelect(view)}>
            {VIEW_LABELS[view] ?? view}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
